import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-frame-module',
  templateUrl: './header-frame-module.component.html',
  styleUrls: ['./header-frame-module.component.css']
})
export class HeaderFrameModuleComponent implements OnInit {

  @Input()
  isAdmin: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
